interface Props {
  selected: boolean;
  customSelectedColor?: string;
  customUnselectedColor?: string;
  size?: number;
}

const SvgBarLove: React.FC<Props> = ({
  selected,
  customSelectedColor,
  customUnselectedColor,
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.12501 0.791626C2.84383 0.791626 0.166672 3.46878 0.166672 6.74996C0.166672 8.96871 1.83915 11.0578 3.87793 13.2002C5.91672 15.3427 8.42621 17.5126 10.4255 19.5119C10.5779 19.6642 10.7846 19.7498 11 19.7498C11.2155 19.7498 11.4221 19.6642 11.5745 19.5119C13.5738 17.5126 16.0833 15.3427 18.1221 13.2002C20.1609 11.0578 21.8333 8.96871 21.8333 6.74996C21.8333 3.46878 19.1562 0.791626 15.875 0.791626C13.9919 0.791626 12.3525 1.80264 11 3.52006C9.64756 1.80264 8.00807 0.791626 6.12501 0.791626ZM6.12501 2.41663C7.71131 2.41663 9.03175 3.26076 10.3134 5.28788C10.3867 5.40367 10.4881 5.49905 10.6081 5.56514C10.7282 5.63122 10.863 5.66588 11 5.66588C11.137 5.66588 11.2718 5.63122 11.3919 5.56514C11.5119 5.49905 11.6133 5.40367 11.6866 5.28788C12.9683 3.26076 14.2887 2.41663 15.875 2.41663C18.2781 2.41663 20.2083 4.34689 20.2083 6.74996C20.2083 8.05204 18.9016 10.0255 16.9456 12.0809C15.162 13.9553 12.9448 15.9136 11 17.8097C9.05525 15.9136 6.83806 13.9553 5.05437 12.0809C3.09836 10.0255 1.79167 8.05204 1.79167 6.74996C1.79167 4.34689 3.72193 2.41663 6.12501 2.41663Z"
        className={`${
          selected
            ? `fill-${customSelectedColor || "white"}`
            : `fill-${customUnselectedColor || "primary"}`
        }`}
      />
    </svg>
  );
};

export default SvgBarLove;
